<template>
  <div>
    <button
      v-print="printObj"
      class="btn btn-primary print_me"
      ref="printMeBtnRef"
    >
      Print again
    </button>
    <div class="loading" v-show="printLoading">
      <div
        class="spinner-border m-3 text-light"
        style="width: 45px; height: 45px; border-width: 4.8px"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <Invoice id="print_me" />
  </div>
</template>


<script>
import { reactive, toRefs, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import Invoice from "./Invoice";
import "./print.css";

export default {
  components: { Invoice },
  name: "InvoicePrint",

  setup() {
    const store = useStore();
    const printMeBtnRef = ref();

    // State
    const state = reactive({
      accounts: computed(() => store.getters["purl/getAccounts"]),
      printLoading: true,
      printedOnce: false,
      printObj: {
        id: "print_me",
        popTitle: "Print Invoice",
        beforeOpenCallback() {
          state.printLoading = true;
        },
        openCallback() {
          state.printLoading = false;
        },
      },
    });
    watch(state, () => {
      if (state.accounts && !state.printedOnce) {
        setTimeout(() => {
          printMeBtnRef.value?.click();
          state.printedOnce = true;
        }, 3000);
      }
    });
    return { ...toRefs(state), store, printMeBtnRef };
  },
};
</script>

<style lang="scss" scoped>
.print_me {
  position: absolute;
  top: 20px;
  z-index: 1;
  right: 23px;
}
.loading {
  position: fixed;
  z-index: 1000;
  background-color: rgba(gray, 0.6);
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>